import React, { useEffect, useState } from "react";
import { utils } from "../../Helpers/utils";
import {
  SearchInput,
  SelectInput,
  Pagination,
  searchIcon,
  Toast,
} from "../../Components";
import InfluencerOfferItem from "./InfluencerOfferItem";
import { offerService } from "../../Services";
const selectDescList = [
  { id: "1", value: "All" },
  { id: "status", value: "Status" },
  { id: "type", value: "Offer type" },
  { id: "rate", value: "Rate" },
];

export default function InfluencerOffer(props) {
  // eslint-disable-next-line
  const [selectDesc, setselectDesc] = useState(selectDescList[0].value);
  const [isloaded, setIsLoaded] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [offerDetails, setOfferDetails] = useState([]);
  const [toastList, setToastList] = useState([]);
  const [paginationData, setPaginationData] = useState({});
  const [searchList, setSearchList] = useState(false);
  const [searchString, setSearchString] = useState("");
  const [disableSearchBox, setDisableSearchBox] = useState(false);

  useEffect(() => {
    fetchData();
  }, [page, searchList]);
  async function fetchData() {
    try {
      let filter = "";
      if (searchString !== "") {
        if (filter !== "") {
          filter += "&filter[" + selectDesc + "]=" + searchString;
        } else {
          filter = "filter[" + selectDesc + "]=" + searchString;
        }
      } else {
        if (selectDesc === "lastyr" || selectDesc === "30days") {
          filter = "filter[created_at]=" + selectDesc;
        }
      }
      const res = await offerService.getAll({
        page: page,
        pageSize,
        filter: filter,
      });

      let paginationObj = utils.createPaginationData(res.data);
      setPaginationData(paginationObj);
      setOfferDetails(res.data.data);
      setIsLoaded(true);
    } catch (err) {
      addToast({
        error: true,
        msg: err,
        id: `${Date.now()}-${toastList.length}`,
      });
    }
  }

  // const downloadCsv = async () => {
  //   try {
  //     let filter = "";
  //     if (searchString !== "") {
  //       if (filter !== "") {
  //         filter += "&filter[" + selectDesc + "]=" + searchString;
  //       } else {
  //         filter = "filter[" + selectDesc + "]=" + searchString;
  //       }
  //     } else {
  //       if (selectDesc === "lastyr" || selectDesc === "30days") {
  //         filter = "filter[created_at]=" + selectDesc;
  //       }
  //     }
  //     const response = await offerService.getAll({
  //       page: page,
  //       pageSize,
  //       filter: filter,
  //       fileType: "csv",
  //     });
  //     utils.downloadFile(response, "offer_page_" + page + ".csv");
  //   } catch (err) {
  //     addToast({
  //       error: true,
  //       msg: err,
  //       id: `${Date.now()}-${toastList.length}`,
  //     });
  //   }
  // };
  const onPaginate = (page) => {
    setPage(page);
  };

  const addToast = (data) => {
    const newToastList = [...toastList];
    newToastList.push({ ...data, id: `${Date.now()}-${toastList.length}` });
    setToastList(newToastList);
  };

  useEffect(() => {
    const keyDownHandler = (event) => {
      if (event.key === "Enter") {
        search();
      }
    };
    document.addEventListener("keydown", keyDownHandler);
    return () => {
      document.removeEventListener("keydown", keyDownHandler);
    };
  }, [searchString]);

  const changeMediumDesc = (item) => {
    setselectDesc(item.id);
    setPage(1);
    if (item.id === "lastyr" || item.id === "30days") {
      setDisableSearchBox(true);
    } else {
      setDisableSearchBox(false);
    }
    setSearchString("");
    setSearchList(!searchList);
  };

  const setSearchStringText = (event) => {
    if (event.target.value === "") {
      setSearchList(!searchList);
    }
    setSearchString(event.target.value);
  };

  const search = () => {
    setSearchList(!searchList);
    setPage(1);
  };

  return (
    <>
      {isloaded && (
        <>
          <div className="main">
            <div className="main__inner">
              {isloaded  && (
                <div className="billing dashboard">
                  <div className="billing__table-title pag paginationEnd">
                    <div className="billing__table-title-inner">
                      <SelectInput
                        list={selectDescList}
                        selected={selectDescList[0]}
                        onChange={changeMediumDesc}
                      />
                      <SearchInput
                        type="text"
                        icon={searchIcon}
                        placeholder="Search"
                        onClick={search}
                        onChange={setSearchStringText}
                        value={searchString}
                        disable={disableSearchBox}
                      />
                    </div>
                  </div>
                  <div className="billing__table">
                    <table>
                      <thead>
                        <tr>
                          <th></th>
                          <th>Date</th>
                          <th>Brand</th>
                          <th>Description</th>
                          <th>Offered Amt</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {offerDetails.length > 0 ? (
                          <>
                            {offerDetails.map((item, index) => {
                              return (
                                <InfluencerOfferItem 
                                  user={props.user}
                                  reFetchData={fetchData}
                                  onStartChat={props.onStartChat}
                                  key={index}
                                  {...item}
                                  setOfferSelectedForReview={
                                    props.setOfferSelectedForReview
                                  }
                                />
                              );
                            })}
                          </>
                        ) : (
                          <tr>
                            <td colSpan="5" style={{ textAlign: "center" }}>
                              No records
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div className="billing__table-footer paginationEnd">
                    {offerDetails && offerDetails.length > 0 && (
                      <Pagination
                        perPage={paginationData["per_page"]}
                        total={paginationData["total"]}
                        currentPage={paginationData["current_page"]}
                        totalPages={paginationData["total_pages"]}
                        onPaginate={onPaginate}
                      />
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
          {toastList && <Toast list={toastList} setList={setToastList} />}
        </>
      )}
    </>
  );
}
